module.exports = __webpack_public_path__ + "img/one-column-grid-help.41b431ff.png";